// extracted by mini-css-extract-plugin
export default {"wrapper":"HttpError_wrapper__OEnWz","code":"HttpError_code__zf1my","title":"HttpError_title__9D78l","link":"HttpError_link__Qpf7C"};